/**
 * WebKit detection for the hero gravity well (see VoidLayer.js).
 * Safari on macOS and EVERY iOS browser (all WebKit) cannot apply the
 * #void-warp SVG filter to an HTML element; they get an SVG rendition of
 * the same effect instead.
 */
export function isWebKitOnly() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const isIOS = /iPad|iPhone|iPod/.test(ua)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isDesktopSafari = /Safari/.test(ua) && !/Chrome|Chromium|CriOS|Edg|OPR|Android|Firefox/.test(ua);
  return isIOS || isDesktopSafari;
}
